import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentTurnsDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor(private http: HttpClient) { }

  public getTurnsAppointments(context, lang, udid, datetimeFrom, datetimeTo, centerInternalIdList, turnFormInternalIdList, turnDeskInternalIdList, appointmentChecked) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { datetimeFrom, datetimeTo, centerInternalIdList, turnFormInternalIdList, turnDeskInternalIdList, appointmentChecked };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_getTurnAppointedList', item, options);
  }

  public validateAppointment(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_validateAppointment', item, options);
  }

  public getForms(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnFormMaintenance/ws_getTurnFormsList', item, options);
  }

  public getDesks(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/turnMaintenance/ws_getTurnDeskList', item, options);
  }
  public deleteAppointment(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'api/v2.0/appointment/appointment/delete', item, options);
  }
}
